import { render, staticRenderFns } from "./ShowInvoices.vue?vue&type=template&id=7080efca&scoped=true"
import script from "./ShowInvoices.vue?vue&type=script&lang=js"
export * from "./ShowInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7080efca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7080efca')) {
      api.createRecord('7080efca', component.options)
    } else {
      api.reload('7080efca', component.options)
    }
    module.hot.accept("./ShowInvoices.vue?vue&type=template&id=7080efca&scoped=true", function () {
      api.rerender('7080efca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/invoices/components/ShowInvoices.vue"
export default component.exports